import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/app/auth/login.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-citationnotices',
    templateUrl: './citationnotices.component.html',
    styleUrls: ['./citationnotices.component.scss'],
    standalone: false
})
export class CitationNoticesComponent implements AfterViewInit {
  @ViewChild(DatalistviewComponent) datalistview!: DatalistviewComponent;

  public isDownloading: boolean = false;

  constructor(private loginService: LoginService, private httpClient: HttpClient) { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Id", "Id"),
    new Datalistviewcolumn("Citation Id", "CitationId"),
    new Datalistviewcolumn("Citation", "CitationReference"),
    new Datalistviewcolumn("Plate", "CitationPlateNumber"),
    new Datalistviewcolumn("DMV Full Name", "CitationDmvFullName"),
    new Datalistviewcolumn("Template", "DocumentTemplateName"),
    new Datalistviewcolumn("Generated (UTC)", "GeneratedAtUtc"),
    new Datalistviewcolumn("Status", "StatusName"),
  ];

  public ngAfterViewInit(): void {
    // Default to Pending subset and newest first
    if (this.datalistview && this.datalistview.Filter) {
      this.datalistview.Filter.Subset = "Pending";
      this.datalistview.Filter.OrderByProperty = "GeneratedAtUtc";
      this.datalistview.Filter.Ascending = false;

      // Filter mutations don't automatically re-query, so refresh explicitly.
      void this.datalistview.Refresh();
    }
  }

  public async generateAndBulkPrintPending(): Promise<void> {
    if (this.isDownloading) return;
    this.isDownloading = true;
    try {
      const url = environment.serverBaseUrl + "/enforcement/citationnotices/downloadpending";
      const headers = new HttpHeaders().set("authorization", "Bearer " + this.loginService.CurrentToken());
      const blob = await lastValueFrom(this.httpClient.get(url, { headers, responseType: 'blob' }));

      // If no content, just refresh the list (timed actions may have run and cleared pending).
      if (!blob || blob.size === 0) {
        await this.datalistview?.Refresh();
        return;
      }

      const fileName = `CitationNotices_${new Date().toISOString().replace(/[:.]/g, '-')}.pdf`;
      const objectUrl = URL.createObjectURL(blob);
      try {
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } finally {
        URL.revokeObjectURL(objectUrl);
      }

      // After download completes (request returned), refresh pending list.
      await this.datalistview?.Refresh();
    } finally {
      this.isDownloading = false;
    }
  }

  public getSubsets() {
    return ["Pending", "Failed", "Collected"];
  }
}

